"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var eth_sig_util_1 = require("@metamask/eth-sig-util");
var errorMap = {
    UNKNOWN_ERROR: 'Ledger device is locked, please unlock to continue',
    INCORRECT_DATA: 'Please enter a valid derivation path'
};
var makeError = function (statusText) { return errorMap[statusText] || statusText; };
var supportsWebUSB = function () {
    return Promise.resolve(!!navigator &&
        !!navigator.usb &&
        typeof navigator.usb.getDevices === 'function');
};
/**
 * Returns the correct ledger transport based on browser compatibility for webUSB.
 * @returns
 */
var getTransport = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supportsWebUSB()];
            case 1:
                if (!(_b.sent())) return [3 /*break*/, 3];
                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@ledgerhq/hw-transport-webusb')); })];
            case 2:
                _a = (_b.sent())["default"];
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@ledgerhq/hw-transport-u2f')); })];
            case 4:
                _a = (_b.sent())["default"];
                _b.label = 5;
            case 5: return [2 /*return*/, (_a).create()];
        }
    });
}); };
var getAccount = function (derivationPath, asset, index, provider, eth) { return __awaiter(void 0, void 0, void 0, function () {
    var dPath, address;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                dPath = "".concat(derivationPath, "/").concat(index);
                return [4 /*yield*/, eth.getAddress(dPath)];
            case 1:
                address = (_c.sent()).address;
                address = address.toLowerCase();
                _a = {
                    derivationPath: dPath,
                    address: address
                };
                _b = {
                    asset: asset.label
                };
                return [4 /*yield*/, provider.getBalance(address)];
            case 2: return [2 /*return*/, (_a.balance = (_b.value = _c.sent(),
                    _b),
                    _a)];
        }
    });
}); };
var getAddresses = function (derivationPath, asset, provider, eth) { return __awaiter(void 0, void 0, void 0, function () {
    var accounts, index, zeroBalanceAccounts, acc;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                accounts = [];
                index = 0;
                zeroBalanceAccounts = 0;
                _a.label = 1;
            case 1:
                if (!(zeroBalanceAccounts < 5)) return [3 /*break*/, 3];
                return [4 /*yield*/, getAccount(derivationPath, asset, index, provider, eth)];
            case 2:
                acc = _a.sent();
                if (acc.balance.value.isZero()) {
                    zeroBalanceAccounts++;
                    accounts.push(acc);
                }
                else {
                    accounts.push(acc);
                    // Reset the number of 0 balance accounts
                    zeroBalanceAccounts = 0;
                }
                index++;
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/, accounts];
        }
    });
}); };
function ledger(_a) {
    var _this = this;
    var customNetwork = _a.customNetwork, basePaths = _a.basePaths, assets = _a.assets;
    var getIcon = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icon')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); };
    return function () {
        var accounts;
        return {
            label: 'Ledger',
            getIcon: getIcon,
            getInterface: function (_a) {
                var EventEmitter = _a.EventEmitter, chains = _a.chains;
                return __awaiter(_this, void 0, void 0, function () {
                    var Eth, ethUtil, SignTypedDataVersion, StaticJsonRpcProvider, _b, createEIP1193Provider, ProviderRpcError, accountSelect, _c, getCommon, bigNumberFieldsToStrings, getHardwareWalletProvider, _d, Transaction, Capability, transport, eth, eventEmitter, ethersProvider, currentChain, scanAccounts, getAccounts, signMessage, ledgerProvider, provider;
                    var _this = this;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@ledgerhq/hw-app-eth')); })];
                            case 1:
                                Eth = (_e.sent())["default"];
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('ethereumjs-util')); })];
                            case 2:
                                ethUtil = _e.sent();
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@metamask/eth-sig-util')); })];
                            case 3:
                                SignTypedDataVersion = (_e.sent()).SignTypedDataVersion;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@ethersproject/providers')); })];
                            case 4:
                                StaticJsonRpcProvider = (_e.sent()).StaticJsonRpcProvider;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@sovryn/onboard-common')); })];
                            case 5:
                                _b = _e.sent(), createEIP1193Provider = _b.createEIP1193Provider, ProviderRpcError = _b.ProviderRpcError;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@sovryn/onboard-hw-common')); })];
                            case 6:
                                accountSelect = (_e.sent()).accountSelect;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@sovryn/onboard-hw-common')); })];
                            case 7:
                                _c = _e.sent(), getCommon = _c.getCommon, bigNumberFieldsToStrings = _c.bigNumberFieldsToStrings, getHardwareWalletProvider = _c.getHardwareWalletProvider;
                                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@ethereumjs/tx')); })];
                            case 8:
                                _d = _e.sent(), Transaction = _d.TransactionFactory, Capability = _d.Capability;
                                return [4 /*yield*/, getTransport()];
                            case 9:
                                transport = _e.sent();
                                eth = new Eth(transport);
                                eventEmitter = new EventEmitter();
                                currentChain = chains[0];
                                scanAccounts = function (_a) {
                                    var derivationPath = _a.derivationPath, chainId = _a.chainId, asset = _a.asset;
                                    return __awaiter(_this, void 0, void 0, function () {
                                        var address, accounts_1, error_1, statusText;
                                        var _b, _c;
                                        return __generator(this, function (_d) {
                                            switch (_d.label) {
                                                case 0:
                                                    _d.trys.push([0, 5, , 6]);
                                                    currentChain =
                                                        chains.find(function (_a) {
                                                            var id = _a.id;
                                                            return id === chainId;
                                                        }) || currentChain;
                                                    ethersProvider = new StaticJsonRpcProvider(currentChain.rpcUrl);
                                                    if (!!basePaths.find(function (item) { return item.value === derivationPath; })) return [3 /*break*/, 3];
                                                    return [4 /*yield*/, eth.getAddress(derivationPath)];
                                                case 1:
                                                    address = (_d.sent()).address;
                                                    address = address.toLowerCase();
                                                    _b = {
                                                        derivationPath: derivationPath,
                                                        address: address
                                                    };
                                                    _c = {
                                                        asset: asset.label
                                                    };
                                                    return [4 /*yield*/, ethersProvider.getBalance(address)];
                                                case 2: return [2 /*return*/, [
                                                        (_b.balance = (_c.value = _d.sent(),
                                                            _c),
                                                            _b)
                                                    ]];
                                                case 3: return [4 /*yield*/, getAddresses(derivationPath, asset, ethersProvider, eth)];
                                                case 4:
                                                    accounts_1 = _d.sent();
                                                    return [2 /*return*/, accounts_1];
                                                case 5:
                                                    error_1 = _d.sent();
                                                    statusText = error_1.statusText;
                                                    throw new Error(makeError(statusText));
                                                case 6: return [2 /*return*/];
                                            }
                                        });
                                    });
                                };
                                getAccounts = function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, accountSelect({
                                                    basePaths: basePaths,
                                                    assets: assets,
                                                    chains: chains,
                                                    scanAccounts: scanAccounts
                                                })];
                                            case 1:
                                                accounts = _a.sent();
                                                if (accounts && accounts.length) {
                                                    eventEmitter.emit('accountsChanged', [accounts[0].address]);
                                                }
                                                return [2 /*return*/, accounts];
                                        }
                                    });
                                }); };
                                signMessage = function (address, message) { return __awaiter(_this, void 0, void 0, function () {
                                    var account;
                                    return __generator(this, function (_a) {
                                        if (!(accounts && accounts.length && accounts.length > 0))
                                            throw new Error('No account selected. Must call eth_requestAccounts first.');
                                        account = accounts.find(function (account) { return account.address === address; }) ||
                                            accounts[0];
                                        return [2 /*return*/, eth
                                                .signPersonalMessage(account.derivationPath, 
                                            // @ts-ignore
                                            ethUtil.stripHexPrefix(message))
                                                .then(function (result) {
                                                var v = (result['v'] - 27).toString(16);
                                                if (v.length < 2) {
                                                    v = '0' + v;
                                                }
                                                return "0x".concat(result['r']).concat(result['s']).concat(v);
                                            })];
                                    });
                                }); };
                                ledgerProvider = getHardwareWalletProvider(function () { return currentChain === null || currentChain === void 0 ? void 0 : currentChain.rpcUrl; });
                                provider = createEIP1193Provider(ledgerProvider, {
                                    eth_requestAccounts: function () { return __awaiter(_this, void 0, void 0, function () {
                                        var accounts;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, getAccounts()];
                                                case 1:
                                                    accounts = _a.sent();
                                                    if (!Array.isArray(accounts))
                                                        throw new Error('No account selected. Must call eth_requestAccounts first.');
                                                    if (accounts.length === 0) {
                                                        throw new ProviderRpcError({
                                                            code: 4001,
                                                            message: 'User rejected the request.'
                                                        });
                                                    }
                                                    if (!accounts[0].hasOwnProperty('address'))
                                                        throw new Error('No address property associated with the selected account');
                                                    return [2 /*return*/, [accounts[0].address]];
                                            }
                                        });
                                    }); },
                                    eth_selectAccounts: function () { return __awaiter(_this, void 0, void 0, function () {
                                        var accounts;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, getAccounts()];
                                                case 1:
                                                    accounts = _a.sent();
                                                    return [2 /*return*/, accounts.map(function (_a) {
                                                            var address = _a.address;
                                                            return address;
                                                        })];
                                            }
                                        });
                                    }); },
                                    eth_accounts: function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, Array.isArray(accounts) &&
                                                    accounts.length &&
                                                    accounts[0].hasOwnProperty('address')
                                                    ? [accounts[0].address]
                                                    : []];
                                        });
                                    }); },
                                    eth_chainId: function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, (currentChain && currentChain.id) || ''];
                                        });
                                    }); },
                                    eth_signTransaction: function (_a) {
                                        var transactionObject = _a.params[0];
                                        return __awaiter(_this, void 0, void 0, function () {
                                            var account, from, derivationPath, chainId, common, signer, populatedTransaction, transaction, unsignedTx, _b, v, r, s, signedTx;
                                            return __generator(this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        if (!accounts || !Array.isArray(accounts) || !accounts.length)
                                                            throw new Error('No account selected. Must call eth_requestAccounts first.');
                                                        if (transactionObject.hasOwnProperty('from')) {
                                                            account = accounts.find(function (account) { return account.address === transactionObject.from; });
                                                        }
                                                        account = account ? account : accounts[0];
                                                        from = account.address, derivationPath = account.derivationPath;
                                                        // Set the `from` field to the currently selected account
                                                        transactionObject = __assign(__assign({}, transactionObject), { from: from });
                                                        chainId = currentChain.hasOwnProperty('id')
                                                            ? Number.parseInt(currentChain.id)
                                                            : 1;
                                                        return [4 /*yield*/, getCommon({ customNetwork: customNetwork, chainId: chainId })];
                                                    case 1:
                                                        common = _c.sent();
                                                        transactionObject.gasLimit =
                                                            transactionObject.gas || transactionObject.gasLimit;
                                                        // 'gas' is an invalid property for the TransactionRequest type
                                                        delete transactionObject.gas;
                                                        signer = ethersProvider.getSigner(from);
                                                        return [4 /*yield*/, signer.populateTransaction(transactionObject)];
                                                    case 2:
                                                        populatedTransaction = _c.sent();
                                                        populatedTransaction =
                                                            bigNumberFieldsToStrings(populatedTransaction);
                                                        transaction = Transaction.fromTxData(populatedTransaction, {
                                                            common: common
                                                        });
                                                        unsignedTx = transaction.getMessageToSign(false);
                                                        // If this is not an EIP1559 transaction then it is legacy and it needs to be
                                                        // rlp encoded before being passed to ledger
                                                        if (!transaction.supports(Capability.EIP1559FeeMarket)) {
                                                            unsignedTx = ethUtil.rlp.encode(unsignedTx);
                                                        }
                                                        return [4 /*yield*/, eth.signTransaction(derivationPath, unsignedTx.toString('hex'))];
                                                    case 3:
                                                        _b = _c.sent(), v = _b.v, r = _b.r, s = _b.s;
                                                        signedTx = Transaction.fromTxData(__assign(__assign({}, populatedTransaction), { v: "0x".concat(v), r: "0x".concat(r), s: "0x".concat(s) }), { common: common });
                                                        return [2 /*return*/, signedTx ? "0x".concat(signedTx.serialize().toString('hex')) : ''];
                                                }
                                            });
                                        });
                                    },
                                    eth_sendTransaction: function (_a) {
                                        var baseRequest = _a.baseRequest, params = _a.params;
                                        return __awaiter(_this, void 0, void 0, function () {
                                            var signedTx, transactionHash;
                                            return __generator(this, function (_b) {
                                                switch (_b.label) {
                                                    case 0: return [4 /*yield*/, provider.request({
                                                            method: 'eth_signTransaction',
                                                            params: params
                                                        })];
                                                    case 1:
                                                        signedTx = _b.sent();
                                                        return [4 /*yield*/, baseRequest({
                                                                method: 'eth_sendRawTransaction',
                                                                params: [signedTx]
                                                            })];
                                                    case 2:
                                                        transactionHash = _b.sent();
                                                        return [2 /*return*/, transactionHash];
                                                }
                                            });
                                        });
                                    },
                                    eth_sign: function (_a) {
                                        var _b = _a.params, address = _b[0], message = _b[1];
                                        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_c) {
                                            return [2 /*return*/, signMessage(address, message)];
                                        }); });
                                    },
                                    personal_sign: function (_a) {
                                        var _b = _a.params, message = _b[0], address = _b[1];
                                        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_c) {
                                            return [2 /*return*/, signMessage(address, message)];
                                        }); });
                                    },
                                    eth_signTypedData: function (_a) {
                                        var _b = _a.params, address = _b[0], typedData = _b[1];
                                        return __awaiter(_this, void 0, void 0, function () {
                                            var account, domainHash, messageHash;
                                            return __generator(this, function (_c) {
                                                if (!(accounts && accounts.length && accounts.length > 0))
                                                    throw new Error('No account selected. Must call eth_requestAccounts first.');
                                                account = accounts.find(function (account) { return account.address === address; }) ||
                                                    accounts[0];
                                                if (typeof typedData === 'string') {
                                                    typedData = JSON.parse(typedData);
                                                }
                                                domainHash = eth_sig_util_1.TypedDataUtils.hashStruct('EIP712Domain', typedData.domain, typedData.types, SignTypedDataVersion.V3).toString('hex');
                                                messageHash = eth_sig_util_1.TypedDataUtils.hashStruct(typedData.primaryType, typedData.message, typedData.types, SignTypedDataVersion.V3).toString('hex');
                                                return [2 /*return*/, eth
                                                        .signEIP712HashedMessage(account.derivationPath, domainHash, messageHash)
                                                        .then(function (result) {
                                                        var v = (result['v'] - 27).toString(16);
                                                        if (v.length < 2) {
                                                            v = '0' + v;
                                                        }
                                                        return "0x".concat(result['r']).concat(result['s']).concat(v);
                                                    })];
                                            });
                                        });
                                    },
                                    eth_signTypedData_v4: function (_a) {
                                        var _b = _a.params, address = _b[0], typedData = _b[1];
                                        return __awaiter(_this, void 0, void 0, function () {
                                            var account, domainHash, messageHash;
                                            return __generator(this, function (_c) {
                                                if (!(accounts && accounts.length && accounts.length > 0))
                                                    throw new Error('No account selected. Must call eth_requestAccounts first.');
                                                account = accounts.find(function (account) { return account.address === address; }) ||
                                                    accounts[0];
                                                if (typeof typedData === 'string') {
                                                    typedData = JSON.parse(typedData);
                                                }
                                                domainHash = eth_sig_util_1.TypedDataUtils.hashStruct('EIP712Domain', typedData.domain, typedData.types, SignTypedDataVersion.V4).toString('hex');
                                                messageHash = eth_sig_util_1.TypedDataUtils.hashStruct(typedData.primaryType, typedData.message, typedData.types, SignTypedDataVersion.V4).toString('hex');
                                                return [2 /*return*/, eth
                                                        .signEIP712HashedMessage(account.derivationPath, domainHash, messageHash)
                                                        .then(function (result) {
                                                        var v = (result['v'] - 27).toString(16);
                                                        if (v.length < 2) {
                                                            v = '0' + v;
                                                        }
                                                        return "0x".concat(result['r']).concat(result['s']).concat(v);
                                                    })];
                                            });
                                        });
                                    },
                                    wallet_switchEthereumChain: function (_a) {
                                        var chainId = _a.params[0].chainId;
                                        return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_b) {
                                                currentChain =
                                                    chains.find(function (_a) {
                                                        var id = _a.id;
                                                        return id === chainId;
                                                    }) || currentChain;
                                                if (!currentChain)
                                                    throw new Error('chain must be set before switching');
                                                eventEmitter.emit('chainChanged', currentChain.id);
                                                return [2 /*return*/, null];
                                            });
                                        });
                                    },
                                    wallet_addEthereumChain: null
                                });
                                provider.on = eventEmitter.on.bind(eventEmitter);
                                return [2 /*return*/, {
                                        provider: provider
                                    }];
                        }
                    });
                });
            }
        };
    };
}
exports["default"] = ledger;
